//* Servicio de alertas centralizado

import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  clear() {
    throw new Error('Method not implemented.');
  }
  process({
    title,
    text,
    timer,
    showCancelButton = false,
    showConfirmButton = false,
    allowOutsideClick = false,
    allowEscapeKey = false,
    allowEnterKey = false,
  }: {
    title?: string;
    text?: string;
    timer?: number;
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
    allowOutsideClick?: boolean;
    allowEscapeKey?: boolean;
    allowEnterKey?: boolean;
  } = {}) {
    Swal.fire({
      title: title,
      text: text,
      timer: timer,
      timerProgressBar: true,
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      allowEnterKey: allowEnterKey,
      showConfirmButton: showConfirmButton,
      showCancelButton: showCancelButton,
      customClass: {
        popup: 'process-popup',
        loader: 'swal-loader-previnca',
        title: 'swal-title-previnca',
        htmlContainer: 'swal-text-previnca',
        confirmButton: 'swal-btn-confirm',
        cancelButton: 'swal-btn-cancel',
      },
      buttonsStyling: false, //por default es TRUE, y lo que hace es agregarle el estilo predeterminados al modal. Por eso esta en FALSE
      didOpen: () => {
        Swal.showLoading(); // <-- acá va el spinner
      },
    });

    return {
      close: () => Swal.close(),
      // update: (updateOpts: SweetAlertOptions) => Swal.update(updateOpts),
      // isOpen: () => Swal.isVisible(),
    };
  }

  success({
    title,
    text,
    timer,
    showCancelButton = false,
    showConfirmButton = false,
    allowOutsideClick = true,
    allowEscapeKey = true,
    allowEnterKey = false,
  }: {
    title?: string;
    text?: string;
    timer?: number;
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
    allowOutsideClick?: boolean;
    allowEscapeKey?: boolean;
    allowEnterKey?: boolean;
  } = {}) {
    return Swal.fire({
      icon: 'success',
      title: title,
      text: text || '',
      timer: timer,
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      allowEnterKey: allowEnterKey,
      showConfirmButton: showConfirmButton,
      showCancelButton: showCancelButton,
      customClass: {
        popup: 'success-popup',
        title: 'swal-title-previnca',
        htmlContainer: 'swal-text-previnca',
        confirmButton: 'swal-btn-confirm',
        cancelButton: 'swal-btn-cancel',
      },
      buttonsStyling: false,
    });
  }

  error({
    title,
    text,
    timer,
    showCancelButton = false,
    showConfirmButton = false,
    allowOutsideClick = true,
    allowEscapeKey = true,
    allowEnterKey = false,
  }: {
    title?: string;
    text?: string;
    timer?: number;
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
    allowOutsideClick?: boolean;
    allowEscapeKey?: boolean;
    allowEnterKey?: boolean;
  } = {}) {
    return Swal.fire({
      icon: 'error',
      title: title,
      text: text || '',
      timer: timer,
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      allowEnterKey: allowEnterKey,
      showConfirmButton: showConfirmButton,
      showCancelButton: showCancelButton,
      customClass: {
        popup: 'error-popup',
        title: 'swal-title-previnca',
        confirmButton: 'swal-btn-confirm',
        cancelButton: 'swal-btn-cancel',
        htmlContainer: 'swal-text-previnca',
      },
      buttonsStyling: false,
    });
  }

  confirm({
    title,
    text,
    html,
    timer,
    showCancelButton = true,
    showConfirmButton = true,
    allowOutsideClick = true,
    allowEscapeKey = true,
    allowEnterKey = false,
    confirmButtonText,
    cancelButtonText,
  }: {
    title?: string;
    text?: string;
    html?: string;
    timer?: number;
    showCancelButton?: boolean;
    showConfirmButton?: boolean;
    allowOutsideClick?: boolean;
    allowEscapeKey?: boolean;
    allowEnterKey?: boolean;
    confirmButtonText?: string;
    cancelButtonText?: string;
  } = {}) {
    return Swal.fire({
      title: title,
      text: html ? undefined : text || '',
      ...(html !== undefined ? { html } : {}),
      icon: 'warning',
      timer: timer,
      showConfirmButton: showConfirmButton,
      allowOutsideClick: allowOutsideClick,
      allowEscapeKey: allowEscapeKey,
      allowEnterKey: allowEnterKey,
      confirmButtonText: confirmButtonText,
      showCancelButton: showCancelButton,
      cancelButtonText: cancelButtonText,
      customClass: {
        popup: 'warning-popup',
        title: 'swal-title-previnca',
        htmlContainer: 'swal-text-previnca',
        confirmButton: 'swal-btn-confirm',
        cancelButton: 'swal-btn-cancel',
      },
      buttonsStyling: false,
    });
    // showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
  }

  /**
   * Muestra un toast (Swal en modo toast) con defaults estables.
   *
   * - `html` tiene precedencia sobre `text` (comportamiento heredado de Swal).
   * - El caller es responsable de no pasar input de usuario sin sanitizar en `html`.
   * - `didOpen` se expone para callers que necesiten registrar handlers
   *   programáticamente sobre el popup del toast (no se usa en el caso base).
   */
  toast({ title, text, html, didOpen, icon = 'success', timer = 3000, position = 'top-end', width }: {
    title?: string;
    text?: string;
    html?: string;
    didOpen?: (popup: HTMLElement) => void;
    icon?: 'success' | 'error' | 'warning' | 'info' | 'question';
    timer?: number | false;
    position?: 'top' | 'top-start' | 'top-end' | 'top-left' | 'top-right' | 'center' | 'center-start' | 'center-end' | 'center-left' | 'center-right' | 'bottom' | 'bottom-start' | 'bottom-end' | 'bottom-left' | 'bottom-right';
    width?: string | number;
  } = {}) {
    Swal.fire({
      toast: true,
      position,
      icon,
      title,
      text,
      ...(html !== undefined ? { html } : {}),
      ...(didOpen !== undefined ? { didOpen } : {}),
      ...(timer === false ? {} : { timer, timerProgressBar: true }),
      ...(width !== undefined ? { width } : {}),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: 'toast-popup',
        title: 'swal-title-previnca',
        htmlContainer: 'swal-text-previnca',
      },
      buttonsStyling: false,
    });
  }
}
